/**
 * Entidad que representa el nivel de riesgos
 */
export type RiskLevel = 'bajo' | 'medio' | 'alto';

/**
 * Entidad que representa el color del nivel de riesgo para datos backend
 */
export type ColorRiskLevel = 'verde' | 'amarillo' | 'rojo';

/**
 * Colores del nivel de riesgo
 */
export const riskLevelColors: ColorRiskLevel[] = ['rojo', 'amarillo', 'verde'];

/**
 * Mapa de relaciones que muestra cada nivel de riesgo con su etiqueta
 */
export const RiskLevelLabels: Record<RiskLevel, ColorRiskLevel> = {
  bajo: 'verde',
  medio: 'amarillo',
  alto: 'rojo',
};
